<script lang="ts">
  import { StoryblokComponent } from '@storyblok/svelte';
  import type { MaterialBlock } from '@storyblok-types';
  const { blok }: { blok: MaterialBlock } = $props();
</script>

{#each blok.body ?? [] as item, i (item._uid)}
  <StoryblokComponent blok={item} blockIndex={i} />
{/each}
